import { createAsyncSelectors } from '@lib/selectors';
import { setJWTToken } from '@sonar-software/sonar-ts-lib';
import { useAction } from './useAction';
import { usePrevious } from './usePrevious';
import { useSonarSelector } from './useSonarSelector';
import { coreActions } from '@sonar-software/sonar-core';
import { useCallback, useEffect, useRef } from 'react';
const linkSelectors = createAsyncSelectors((state) => state.core.organizations.link.post);
export function useSalesforceLink() {
    const response = useSonarSelector(linkSelectors.data);
    const hasError = useSonarSelector(linkSelectors.isErrored);
    const hasFailure = useSonarSelector(linkSelectors.isFailed);
    const hasSuccess = useSonarSelector(linkSelectors.isReceived);
    const status = useSonarSelector(linkSelectors.statusCode);
    const previousHasError = usePrevious(hasError);
    const previousHasFailure = usePrevious(hasFailure);
    const previousHasSuccess = usePrevious(hasSuccess);
    const onResponseRef = useRef(null);
    const linkSalesforce = useAction(coreActions.requestPostCoreOrganizationsLink);
    const hasNewError = hasError && !previousHasError;
    const hasNewFailure = hasFailure && !previousHasFailure;
    const hasNewSuccess = hasSuccess && !previousHasSuccess;
    const shouldTriggerResponse = hasNewError || hasNewFailure || hasNewSuccess;
    useEffect(() => {
        if (onResponseRef.current && shouldTriggerResponse) {
            onResponseRef.current(response, status);
        }
    }, [response, shouldTriggerResponse, status]);
    useEffect(() => {
        if (response === null || response === void 0 ? void 0 : response.updatedUserAccessToken) {
            setJWTToken(response.updatedUserAccessToken);
        }
    }, [response === null || response === void 0 ? void 0 : response.updatedUserAccessToken]);
    const link = useCallback((options) => {
        const { code, organizationId, onResponse } = options;
        onResponseRef.current = onResponse !== null && onResponse !== void 0 ? onResponse : null;
        linkSalesforce({
            code,
            organizationId
        });
    }, [linkSalesforce]);
    return link;
}
